import React,{useRef, useState, useEffect} from "react";
import { 
	Link, 
	useParams, 
	useLocation 
}									from "react-router-dom";
import { 
	Col, 
	Row, 
	Form, 
	Nav, 
	Card,
	Button, 
	Badge, 
	InputGroup, 
	Spinner ,
	Dropdown
}									from "react-bootstrap";
import {
	setUrlParam, 
	normalizeOwner 
}									from "../utils/functions";
import Select						from "react-select";
import Footer						from "../layouts/Footer";
import Sidebar						from "../layouts/Sidebar";
import Header						from "../layouts/Header";
import parse						from 'html-react-parser';
import {projectPhaseColors}			from "../data/ProjectStatusColor";
import Country						from "../classes/Country";
import atlasApi						from "../utils/atlasapi";
import authApi						from "../utils/authApi";
import Loader						from "../components/Loader";
import DialogOwner					from "../layouts/DialogOwner";
import Filter						from "../components/Filter";
import SearchOwner					from "../components/SearchOwner";
import UserMenu						from "../components/UserMenu";
import DataTable					from 'react-data-table-component';
import Pagination					from "../components/Pagination";
import IconSelector					from "../components/IconSelector";
import {ownerTypes}					from "../data/ownerTypes";
import {
	Sliders, 
	Star, 
	Files, 
	DotsThreeVertical, 
	PencilSimple, 
	Trash, 
	FloppyDisk, 
	UploadSimple, 
	Polygon
}									from "@phosphor-icons/react";

import EditNow						from "../components/EditNow";
//import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
 
//mapboxgl.accessToken = 'pk.eyJ1IjoiZXNwZW52aW5kciIsImEiOiJjbGZpOXoyamIyYW1wM3FuMXBidjlvcXl5In0.XDmLF8QmTyYR-PiDcnDFGQ';


const SORT_COLUMNS = {
	'id':          'id',
	'firstName':   'first_name',
	'lastName':    'last_name',
	'fullName':    'full_name',
	'companyName': 'company_name',
	'street':      'street',
	'city':        'city',
	'phone':       'phone',
	'email':       'email',
	'zipcode':     'zipcode',
	'identifier':  'identifier',
	'country':     'country',
};

// Maps DataTable column id → SORT_COLUMNS key where they differ
const COLUMN_FIELDS = {
	'name': 'fullName',
};

export default function LandOwners() {

	const [pageTitle,setPageTitle]		= useState('List of Owners');
	const location = useLocation();
	const params = new URLSearchParams(location.search);
	
	var countrySel		= params.get("country") && Country.get(params.get("country")) ? params.get("country").split(",")	: [];
	var typeSel			= params.get("owner_type")	? params.get("owner_type").split(",")	: [];
	var searchSel		= params.get("search")	? params.get("search")				: "";
	
	document.body.className="owners";
	
	
	var lastCall;
	/*
	options of the sort by select box
	*/
	const ownersSortOptions = [
		{label:"Name", value:"name"},
		{label:"Email", value:"email"}
	];
	
	const [orderBy, setOrder]					= useState('');
	const [needle, setNeedle]					= useState(searchSel);
	const [data,setOwners]						= useState([]);
	const [user,setUser]						= useState({});
	const [showFilters,setShowFilters]			= useState(false);
	const [pending,setPending]					= useState(true); //status variable set when all data is loaded
	const [filterCountry, setFilterCountry]		= useState(new Set(countrySel));
	const [filterOwnerType, setFilterOwnerType]	= useState(new Set(typeSel));
	const [refresh,setRefresh]					= useState('');
	const [ownerDialog, setOwnerDialog]			= useState({open: false, owner: null});
	const [listSort,setListSort]				= useState({sortBy:'name', sortOrder:'asc'});
	const [totalRows, setTotalRows]				= useState(0);
	const [currentPage, setCurrentPage]			= useState(1);
	const [perPage, setPerPage]					= useState(10);
	const [filterFav, setFilterFav]				= useState(false);
	const [userLoaded, setUserLoaded]			= useState(false);
	
	
	
	const countryComp = React.createRef();
	
	
	const getData = ()=>{ 
		

		
		Promise.all([atlasApi.getToken()])
		.then((res) => {
			
			const dataRequests = [
				authApi.getUser()

			];
			return Promise.all(dataRequests);
		}).then((res)=>{
			var responses = res.map((response) => {
				if(response.json)
					return response.json();
				return response;
			});
			return Promise.all(responses);
		}).then(function(responses) {
			var user = responses[0];
			setUser(user);
			const rowsPerPage = user.settings?.owners?.rowsPerPage ?? 10;
			var filters				= user.settings?.owners?.filters ?? user.settings.filters;
			var searchParams = {
				page: 1,
				limit: rowsPerPage,
				query: needle,
			}
			
			
			if(!filterCountry.length && filters.country && filters.country.length){
				
				
				filters.country.splice(0, filters.country.length,...filters.country.filter((a)=>{return !!Country.get(a)}))
				
				selectFilter("country", filters.country, setFilterCountry)
				searchParams["country"] = filters.country.join(",");
			}
			if(!filterOwnerType.length && filters.owner_type && filters.owner_type.length){
				selectFilter("owner_type", filters.owner_type, setFilterOwnerType);
				searchParams["owner_type"] = filters.owner_type;
			}
			if(!filterFav && filters.favorites){
				selectFilter("favorites", filters.favorites, setFilterFav);
				searchParams["favorites"] = filters.favorites;
			}
			
			if(user.settings?.owners?.sort){
				setListSort(user.settings.owners.sort);
			}
			
			document.title = process.env.REACT_APP_DOC_TITLE;
			setPerPage(rowsPerPage);
			setUserLoaded(true);
		});

		
		
	};

	
	const fetchOwners = async ({ page, limit, query, country, owner_type, favorites_only, sort}) => {
		setPending(true);
		const params = { page, limit };
		
		if(query) 
			params.query = query;
		if(owner_type.size) 
			params.owner_type = Array.from(owner_type).join(',');
		if(country.size) 
			params.country = Array.from(country).join(',');
		if(favorites_only) 
			params.favorites_only = 'true';
		if(sort) {
			params.sort_by = SORT_COLUMNS[sort.sortBy] ?? sort.sortBy;
			params.sort_order = sort.sortOrder;
		}
		
		try {
			const resp = await atlasApi.searchOwners(params);

			resp.results.map(normalizeOwner);

			setOwners(resp.results || []);
			setTotalRows(resp.total || 0);
		} finally {
			setPending(false);
		}
	};

	var selectFilter = (filter, opts, callback) => {

		const optsStr = Array.isArray(opts) ? opts.map(obj => obj.value ?? obj).join(",") : opts;


		setUrlParam(filter, optsStr);

		if(Array.isArray(opts)){
			callback(new Set(opts));
		}
		else {
			callback(opts);
		}

		saveFilter(filter, Array.isArray(opts) ? opts.filter(a => a.length) : opts);

		setCurrentPage(1);
	};
	
	const searchNeedle = (item) => {
		
		if(needle.length < 3)
			return true;
		
		/* we use search now, therefor the >-1 condition, eventualy we can use regexp for boolean and search ranking*/
		return 	(item.fullName && item.fullName.match(new RegExp(needle, "i"))) || 
			(item.email && item.email.match(new RegExp(needle, "i"))) || 
			(item.phone && item.phone.match(new RegExp(needle, "i"))) || 
			(item.street && item.street.match(new RegExp(needle, "i"))) || 
			(item.projects && item.projects.length && item.projects.map(a => a.name).join(" ").match(new RegExp(needle, "i")));
	}
	

	useEffect(()=>{
		getData();
	},[])

	useEffect(()=>{
		if (!userLoaded) return;
		fetchOwners({
			page: currentPage,
			limit: perPage,
			query: needle,
			country: filterCountry,
			owner_type: filterOwnerType,
			favorites_only: filterFav,
			sort: listSort
		});
	},[userLoaded, needle, currentPage, perPage, filterCountry, filterOwnerType, filterFav, listSort, refresh]);

	var search = (a) => {

		if(a.target.value.length>2 || !a.target.value.length) {
			setUrlParam("search", a.target.value);
			setNeedle(a.target.value)
		}
	};
	function highlight(str, group1, group2) {
		return "<span class=bg-warning>"+str+"</span>";
	}
	const saveFilter = (filter, value)=>{
		
		if(user && user.userDetails && user.settings){
			if(!user.settings.owners)
				user.settings.owners = {filters:{}};
			user.settings.owners.filters[filter] = value;
			user.email = user.userDetails;
			
			delete user.settings.ownerFilters;
			atlasApi.updateSettings(user);
		}
		
	}
	
	const makelink = (elem, oId) => {
		return <Link to={'/pages/owner/'+oId}>{elem}</Link>
	}
	const makeProjLink = (elem, pId) => {
		return <Link to={'/pages/project/'+pId}>{elem}</Link>
	}
	const handleSetFavorite = function(e, row){
		
		e.stopPropagation();
		e.preventDefault();
		
		const elem = document.querySelector("#star-"+row.id);
		const isActive = elem.classList.contains("active");
		const landowner_id = elem.dataset.landownerid;
		
		
		row.isFavorite = !isActive;
		
		setRefresh(Math.random());
		
		atlasApi.setFavorite2('landowners', !isActive, {landowner_id}, user.userDetails).then((res)=>{
			const el = document.querySelector("#star-"+row.id);
			if(res.id && el){
				el.classList.add("active");
			}	
			if(res.message && el){
				el.classList.remove("active");
			}	
			
		});
		
	}
	
	const handlePageChange = (page) => {
		setCurrentPage(page);
	};

	const handleRowsPerPageChange = (rows) => {
		setPerPage(rows);
		setCurrentPage(1);
		saveRows(rows);
	}
	const saveSort = (sortBy, sortOrder)=>{
		
		if(user && user.userDetails && user.settings){
			
			
			
			if(!user.settings.owners){
				user.settings.owners = {
					filters : {...user.settings.filters},
				}
				delete user.settings.filters;
			}
			user.settings.owners.sort = {
				sortOrder: sortOrder,
				sortBy: COLUMN_FIELDS[sortBy.id] ?? sortBy.id
			}
			user.email = user.userDetails;
			atlasApi.updateSettings(user);
			setListSort(user.settings.owners.sort);
		}
		
	}

	const saveRows = (rows)=>{
		
		if(user && user.userDetails && user.settings){
				
			if(!user.settings.owners){
				user.settings.owners = {
					filters : {...user.settings.filters},
				}
			}
			
			user.settings.owners.rowsPerPage = rows
			
			user.email = user.userDetails;

			atlasApi.updateSettings(user);
		}
		
	}

	const handleEditOwner = (row) => {
		setOwnerDialog({open: true, owner: structuredClone(row), onSave:()=>{setRefresh(Math.random());}});
	}
	
	const listProjects = (o) =>{
		
		return <div className="owner-projects"> { o.projects.map((p)=>{
			return makeProjLink(<Badge variant="primary">{p.name}</Badge>, p.id)
		})}</div>
	}

	const gotoOwner = (oId)=>{
		window.location.href='/pages/owner/'+oId;
	}
	
	const updateOwnerField = (id, field, value) => {
		if(id && field){
			var payload = {
				id:id
			}
			payload[field] = value;
			atlasApi.updateOwner(payload);
		}
	}

	
	return (
		<React.Fragment>
			<div className="header">
			
				<div className="menu">
					<i className="ri-menu-2-fill"></i>
				</div>
				
				
				<div className="middle">
					

					<Link to="/" className="header-logo">Energy Atlas</Link>
					
				</div>
				<div className="logo">
					<img className="img-fluid d-none d-md-block brand-logo" src="/images/allod_atlas_logo.png" alt="Allod"/>
				</div>
				<div className="options">
						{user.userId && <UserMenu user={user} onUpdateUser={setUser} />}
						
				</div>
			</div>
			
			<div className="body dashboard2">
			
				<Sidebar />
				<div className="main owners ">
				
				
					<div className="card">
						<Row>
							<Col xl>

								<Row className="mb-4">
									<Col xl>
										<Row className="p-3 filters">		
											<div>
												<InputGroup className="search-wrp">
													<Form.Control autoFocus  type="text" className="search-input" defaultValue={searchSel} onChange={search} placeholder="Search owners..." />
													<InputGroup.Text id="basic-addon1"><i className="ri-search-line"></i></InputGroup.Text>
												</InputGroup>
											</div>
											<div>
												<label>Country:</label>
												<IconSelector onClick={(vs)=>{selectFilter("country", vs, setFilterCountry)  }} value={filterCountry} options={Country.options}  />
											</div>
											
											<div>
												<label>Type:</label>
												<IconSelector onClick={(vs)=>{selectFilter("owner_type", vs, setFilterOwnerType)  }} value={filterOwnerType} single={true} options={ownerTypes.types}  />
											</div>
											<div>
												<label>Favorites:</label>

												<Star weight={(filterFav ? "fill" : 'bold')} className={"fav-star " + (filterFav ? 'active' : '')} onClick = {(vs)=>{selectFilter("favorites", !filterFav, setFilterFav) } } size={18} />


											</div>
											<div></div>
										</Row>
										<Row className="g-3"></Row>
									</Col>
								</Row>
								<Row className="g-3">




									<DataTable
										data={data}
										columns={[


											{
												name:' ',
												id:'isFavorite',
												selector: row => row.isFavorite,
												format: row => <div className="btn p-0" onClick={(e)=>{handleSetFavorite(e, row)}}><Star id={"star-"+row.id} data-landownerid={row.id} weight={(row.isFavorite ? "fill" : 'bold')} className={"m-0 mb-1 me-1 ms-3 fav-star "+(row.isFavorite ? "active" : '')}  size={20} /></div>,
												sortable:true,
												width:"55px !important",
											},
											{
												name:'Landowner',
												id:'name',
												selector: row => row.fullName,
												format: row => row.fullName,
												sortable:true,
												minWidth:"200px !important",
												style:{
												}
											},
											{
												name:'Type',
												id:'type',
												selector: row => row.type,
												sortable:true,
												format: (row) => <IconSelector options={ownerTypes.get(row.type)} />,
												width:"70px",
												center:true,
											},
											{
												name:'Email',
												id:'email',
												selector: row => row.email,
												sortable:true,
												format: (row) => (<EditNow id={row.id} value={row.email ?? ''} editable={true} onUpdate={(val)=>{updateOwnerField(row.id, "email", val)}} />),
											},
											{
												name:'Phone',
												id:'phone',
												selector: row => row.phone,
												sortable:true,
												format: (row) => row.phone,
												width:"170px",
											},
											{
												name:'Country',
												id:'country',
												selector: row => row.country,
												sortable:true,
												format: (row) => <IconSelector options={Country.get(row.country)} />,
												width:"100px",
												center:true,
											},
											{
												name:'Projects',
												id:'size',
												selector: row => row.projects,
												format: (row) => listProjects(row),
											},

											{
												name:'',
												id:'contextmenu',
												cell: row => (
													<div className="context-menu">
														<Dropdown className="minimal">
															<Dropdown.Toggle className="p-0 px-1" variant="default">
																<DotsThreeVertical size={16} />
															</Dropdown.Toggle>
															<Dropdown.Menu>

																	<Dropdown.Item href="#" onClick={(e)=>{handleEditOwner(row); }}><PencilSimple weight="bold" size={16} /> Edit landowner</Dropdown.Item>
																	{/*<Dropdown.Item href="#" onClick={(e)=>{handleRemoveProject(row); }} className="text-danger" ><Trash weight="bold" size={16} /> Remove project</Dropdown.Item>*/}
															</Dropdown.Menu>
														</Dropdown>
													</div>
												),
												width:"40px",
											},


										]}
										customStyles={{
											headCells:{
												style: {
													padding:'.5rem .3rem',
													minWidth:'0px !important',
													fontWeight:'bold',
													fontSize:"16px"
												}
											},
											cells:{
												style: {
													padding:'.5rem .3rem',
													fontSize:"16px",
													minWidth:'0px !important',
													color:'var(--bs-body-color)',
													'&:last-child':{paddingRight:'1rem'}
												}
											},
											rows:{
												style: {
													minHeight:"0",
												},
												selectedHighlightStyle:{
													backgroundColor:'red'
												}
											},
											pagination : {
												style : {
													width:"100%"
												}
											}
										}}
										noDataComponent=<div className="p-5">There are not owners to display</div>
										highlightOnHover
										sortIcon=<i className="ri-expand-up-down-line"></i>
										sortServer
										progressPending={pending}
										onChangePage={handlePageChange}
										onChangeRowsPerPage={handleRowsPerPageChange}
										onRowClicked={(row)=>{gotoOwner(row.id);}}
										onSort={(selectedColumn, sortDirection, sortedRows) => {saveSort(selectedColumn, sortDirection)}}
										pagination
										paginationServer
										paginationComponent = {Pagination}
										paginationTotalRows={totalRows}
										paginationPerPage={Number(perPage)}
										paginationComponentOptions = {{
											rowsPerPageText: 'Show',
											type: 'landowners',
											rangeSeparatorText: 'of',
											selectAllRowsItemText: 'All',
											perPage: Number(perPage)
										}}

									/>
								</Row>
							</Col>
						</Row>

					</div>
				</div>
			</div>
			
		<DialogOwner setup={ownerDialog} onClose={()=>setOwnerDialog({open: false, owner: null})} />
		</React.Fragment>
	);
}
